export const styles = {
  drawer: {
    width: { xs: '100%', sm: 400 },
    flexShrink: 0,
  },
  drawerPaper: {
    width: { xs: '100%', sm: 400 },
    maxWidth: '90vw',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 2,
    borderBottom: '1px solid',
    borderColor: 'divider',
  },
  content: {
    padding: 2,
    display: 'flex',
    flexDirection: 'column' as const,
    gap: 2,
  },
  actions: {
    display: 'flex',
    gap: 1,
    justifyContent: 'flex-end',
    marginTop: 2,
  },
};